import { parseQueryParamToDateString } from "@/helpers/query-params";

// Ticket date filters use calendar dates; the API compares inclusive UTC timestamps.
export function ticketDateBoundary(date: string | undefined, boundary: "from" | "to"): string | undefined {
  if (!date) {
    return undefined;
  }

  return `${date}T${boundary === "from" ? "00:00:00.000" : "23:59:59.999"}Z`;
}

export function parseTicketFilterDate(value: string | undefined): string | undefined {
  // Keep a calendar date on the same day in browsers west of UTC too.
  const localDate = value && /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value;

  return parseQueryParamToDateString(localDate);
}
